<template lang="html">
    <section :class="['pod', { 'archived': campaign.status === 'archived' }]" v-else>
        <div :class="['pod-container', { 'draft': campaign.status === 'draft' }]" @click="viewCampaigns">
            <header class="pod-header">
                <div class="col-8">
                    <h2 class="title">{{ campaign.property.title }}</h2>
                    <h4 class="section-heading">{{ campaign.agency.displayName }}</h4>
                </div>
                <div class="logo">
                    <div class="img-wrapper">
                        <figure>
                            <img :src='getLogo()'/>
                        </figure>
                    </div>
                </div>
            </header>
            <footer class="pod-footer">
                <template v-if="campaign.status === 'archived'">
                </template>
                <template v-else>
                    <div></div>
                </template>
            </footer>
        </div>
    </section>
</template>

<script>
    import AddButton from '../../helpers/AddButton';

    export default {
        name: 'CampaignItem',
        props: ['addNew', 'campaign'],
        components: {
            AddButton
        },
        methods: {
            getLogo () {
                if (this.campaign.agency.logo) {
                    return process.env.VUE_APP_CDN_URL + this.campaign.agency.logo.location;
                }
                return 'data:image/png;base64,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';
            },
            viewCampaigns() {
                this.$router.push({name: 'AgencyOrders', params: {agency: this.campaign.agency.slug.name}});
            },
            openModal() {
                this.$emit('openModal');
            },
        },
        mounted() {

        }
    }
</script>

<style lang="css">
</style>
